import React from 'react'
import { CardContent, Grid, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import EventTypeSelectionCards from '../../CreateEvent/EventTypeSelectionCards'
import { EventDto } from '../../../interfaces/IEvent'
import { EventType } from '../../../interfaces/IEventEnums'
import type { DateClickArg } from '@fullcalendar/interaction'

interface CalendarNewEventPopoverProps {
  info: DateClickArg
}

const CalendarNewEventPopover: React.FC<CalendarNewEventPopoverProps> = ({ info }: CalendarNewEventPopoverProps) => {
  const navigate = useNavigate()

  const handleEventTypeChange = (name: string, eventType: EventType | null) => {
    if (eventType) {
      info.date.setHours(new Date().getHours())
      info.date.setMinutes(new Date().getMinutes())
      navigate(`/events/create?eventType=${eventType.toString()}&fromDate=${info.date.toISOString()}`)
    }
  }

  return (
    <CardContent>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Ny hendelse
      </Typography>
      <Grid
        container
        rowSpacing={4}
        columnSpacing={3}
        sx={{
          flexDirection: 'row',
          justifyContent: 'center'
        }}>
        <EventTypeSelectionCards newEvent={{} as EventDto} handleEventTypeChange={handleEventTypeChange} />
      </Grid>
    </CardContent>
  );
}

export default CalendarNewEventPopover
